<!-- Overlay a pantalla completa. z-modal-top: debe quedar por encima de un
     detail-modal (z-modal) cuando se lanza inline desde el CRM, y funciona
     igual de bien en la página pública (sin modal padre). -->
<div class="fixed inset-0 z-modal-top flex flex-col bg-black">
  <!-- Cabecera -->
  <div class="flex items-center justify-between gap-3 bg-black/90 px-4 py-2">
    <div class="min-w-0">
      <p class="truncate text-sm font-semibold text-white">
        {{ title || 'Videollamada' }}
      </p>
      @if (formatFechaCabecera()) {
        <p class="truncate text-[11px] text-white/60">{{ formatFechaCabecera() }}</p>
      }
    </div>
    <button
      type="button"
      (click)="onClose()"
      class="flex-shrink-0 rounded-lg bg-white/10 px-4 py-1.5 text-sm font-medium text-white transition-colors hover:bg-white/20">
      Salir
    </button>
  </div>

  <!-- Estado de carga -->
  @if (loading && !error) {
    <div class="flex flex-1 items-center justify-center text-white/70">
      <div class="flex flex-col items-center gap-3">
        <svg class="h-8 w-8 animate-spin text-white/80" fill="none" viewBox="0 0 24 24">
          <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
          <path class="opacity-75" fill="currentColor"
            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"></path>
        </svg>
        <span class="text-sm">Conectando a la videollamada…</span>
      </div>
    </div>
  }

  <!-- Error -->
  @if (error) {
    <div class="flex flex-1 items-center justify-center px-6 text-center">
      <div class="max-w-sm">
        <p class="text-base font-semibold text-white">No se pudo iniciar la videollamada</p>
        <p class="mt-2 text-sm text-white/60">{{ error }}</p>
        <button
          type="button"
          (click)="onClose()"
          class="mt-5 rounded-lg bg-white/10 px-5 py-2 text-sm font-medium text-white transition-colors hover:bg-white/20">
          Cerrar
        </button>
      </div>
    </div>
  }

  <!-- Jitsi monta su iframe DENTRO de este div (parentNode). Siempre presente
       en el DOM para que el ViewChild static esté disponible en ngAfterViewInit. -->
  <div #jitsiContainer class="w-full flex-1" [class.hidden]="loading || error"></div>
</div>
